import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAdmin } from '../store/adminStore';
import { useProductStore } from '../store/productStore';
import { useUserStore } from '../store/userStore';
import { toast } from 'sonner';

function Dashboard() {
  const { stats, fetchStats } = useAdmin();
  const { products, fetchProducts } = useProductStore();
  const { users, fetchUsers } = useUserStore();

  useEffect(() => {
    Promise.all([
      fetchStats().catch((e: Error) => toast.error(e.message)),
      fetchProducts().catch(() => null),
      fetchUsers().catch(() => null),
    ]);
  }, [fetchStats, fetchProducts, fetchUsers]);

  const pendingProducts = products.filter((p) => p.status === 'pending');
  const pendingVendors = users.filter((u) => u.role === 'vendor' && !u.is_vendor_approved);

  return (
    <div className="container">
      <h1 className="page-title">Dashboard</h1>
      <p className="page-subtitle">Overview of the Ludic Drive Assetstore.</p>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Total Users</div>
          <div className="stat-value">{stats?.total_users ?? 0}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Vendors</div>
          <div className="stat-value">{stats?.total_vendors ?? 0}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Pending Vendors</div>
          <div className="stat-value warning">
            <Link to="/users">{stats?.pending_vendors ?? pendingVendors.length}</Link>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Products</div>
          <div className="stat-value">{stats?.total_products ?? 0}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Pending Products</div>
          <div className="stat-value warning">
            <Link to="/products">{stats?.pending_products ?? pendingProducts.length}</Link>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Monthly Revenue (incl. VAT)</div>
          <div className="stat-value success">€{(stats?.monthly_revenue ?? 0).toFixed(2)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Total Revenue (incl. VAT)</div>
          <div className="stat-value success">€{(stats?.total_revenue ?? 0).toFixed(2)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Orders</div>
          <div className="stat-value">{stats?.total_orders ?? 0}</div>
        </div>
      </div>

      <div className="toolbar" style={{ marginTop: '2rem' }}>
        <Link to="/products" className="btn btn--primary">
          Review Pending Products
        </Link>
        <Link to="/users" className="btn btn--secondary">
          Manage Vendors
        </Link>
        <Link to="/orders" className="btn btn--secondary">
          View Orders
        </Link>
        <Link to="/analytics" className="btn btn--secondary">
          Analytics
        </Link>
      </div>
    </div>
  );
}

export default Dashboard;
